const WindowStatePlugin = {
  install(Vue) {
    // const EXTRA_SMALL = 1 // SmartPhone
    const SMALL = 576 // Tablet
    const MEDIUM = 768 // PC
    const LARGE = 992
    const EXTRA_LARGE = 1200

    // ウィンドウの状態
    var state = {
      scrollX: 0,
      scrollY: 0,
      width: 0,
      height: 0,
      isXs: false,
      isSm: false,
      isMd: false,
      isLg: false,
      isXl: false,
      isSP: false,
      isPC: false,
    }

    // クリア
    function clear() {
      state.isXs = false
      state.isSm = false
      state.isMd = false
      state.isLg = false
      state.isXl = false
      state.isSP = false
      state.isPC = false
    }

    // スクロール数値を取得
    function onScroll() {
      state.scrollX = window.pageXOffset
      state.scrollY = window.pageYOffset
    }

    // ウィンドウのサイズを取得
    function onResize() {
      state.width = document.documentElement.clientWidth
      state.height = document.documentElement.clientHeight

      // デバイスタイプ判定
      clear()
      if (state.width < SMALL) {
        state.isXs = true
        state.isSP = true
      } else if (state.width < MEDIUM) {
        state.isSm = true
        state.isSP = true
      } else if (state.width < LARGE) {
        state.isMd = true
        state.isPC = true
      } else if (state.width < EXTRA_LARGE){
        state.isLg = true
        state.isPC = true
      } else {
        state.isXl = true
        state.isPC = true
      }
    }

    document.addEventListener('scroll', onScroll)
    window.addEventListener('resize', onResize)
    // 初期値を更新
    window.addEventListener('load', onScroll)
    onResize()

    // プロパティ $window を定義
    Vue.util.defineReactive(Vue.prototype, '$window', state)
  }
}

export default WindowStatePlugin


// WEBPACK FOOTER //
// ./src/assets/js/util/WindowStatePlugin.js